import script from "./PayTypeDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./PayTypeDialog.vue?vue&type=script&setup=true&lang=js"

import "./PayTypeDialog.vue?vue&type=style&index=0&id=2b4d2be9&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2b4d2be9"]])

export default __exports__